import { EventEmitter } from '../EventEmitter'
/**
 * ace编辑器 {@link https://ace.c9.io/}
 * 
 * @class Editor
 */
export default class Editor extends EventEmitter {
    constructor(proc) {
        super()
        this.proc = proc;
        const src = [
            '/editor/ace.js',
            '/editor/keybinding-emacs.js',
            '/editor/keybinding-sublime.js',
            '/editor/ext-beautify.js',
        ]
        this.loadFile(src, this.loadType.SCRIPT).then(_ => {
            this.loaded = true;
            this.emit('Editor.loaded')
        })
    }
    loadType = {
        'LINK': 'link',
        'SCRIPT': 'script',
    }
    /**
     * 
     * @param { HTMLElement } el 容器ID
     */
    createEditor(el) {
        this.editor = ace.edit(el);
        this.editor.setTheme("ace/theme/twilight");

        this.editor.session.setMode("ace/mode/javascript");

        this.editor.setOptions({
            enableBasicAutocompletion: true,
            enableSnippets: true,
            enableLiveAutocompletion: true,
            wrapBehavioursEnabled: true,
        });

        this.js_beautify = ace.require('ace/ext/beautify')
        this.editor.commands.addCommands(this.js_beautify.commands);
        return this.editor;
    }
    /**
     * @description 格式化代码
     */
    formatCode() {
        console.log(this.js_beautify.beautify(this.editor.session));
    }
    /**
     * 设置初始化代码
     * @param {string} text 
     */
    setValue(text) {
        this.editor.getSession().setValue(text)
    }
    /**
     * 获取编辑器的代码
     * @returns {string} 
     */
    getValue() {
        return this.editor.getSession().getValue()
    }

    loaded = false;
    loadFile(urls = [], type) {
        let that = this;
        return new Promise((res, rej) => {
            let len = urls.length;
            let current = 0
            let load = function (url) {
                let tag = null;
                if (type === that.loadType.LINK) {
                    tag = document.createElement('link')
                    tag.rel = 'stylesheet';
                    tag.href = url;
                } else if (type === that.loadType.SCRIPT) {
                    tag = document.createElement('script');
                    tag.src = url;
                    tag.type = 'text/javascript';
                }
                tag.onload = function () {

                    current++;

                    if (current < len) {

                        load(urls[current])
                    } else {
                        load = null;
                        res(true)
                    }
                }
                tag.onerror = function (ERR) {
                    current++;
                    console.log(ERR)
                    rej(ERR);
                };
                document.querySelector('head').appendChild(tag);
            }
            load(urls[0])
        })

    }
}